import React from "react";
import { Link } from "gatsby";
import Layout from "components/layout";
import SEO from "components/seo";
import Style from "styles/news.module.scss";
import { newsList } from "../../news_data";

const News = () => (
  <Layout>
    <SEO title="新着情報" path="news" />
    <div className={Style.container}>
      <div className={Style.newsHead}>
        <h1 className={Style.newsHead__title}>NEWS</h1>
        <p className={Style.newsHead__sub}>新着情報</p>
      </div>
      <ul className={Style.newsList}>
        {newsList.map((news) => (
          <li key={news.path} className={Style.newsList__item}>
            <Link className={Style.newsList__link} to={news.path}>
              <time className={Style.newsList__date}>{news.date}</time>
              <span className={Style.newsList__title}>{news.title}</span>
            </Link>
          </li>
        ))}
      </ul>
      <div className={Style.newsBack}>
        <Link className={Style.newsBack__link} to="/">
          ＜ TOPへ戻る
        </Link>
      </div>
    </div>
  </Layout>
);

export default News;
